import { isFunction } from 'lodash'

/**
 * Text matcher for the given value with optional text transformation of the given value.
 * @param {*} value - The value optionally being text-transformed.
 * @param {String} text - The text to match in the given (and optionally transformed) value.
 * @param {function} [textTransformation] - A transformation functions for the given value. The function expects a
 *                                          value parameter of any type and returns the text-transformed value as string.
 * @returns {boolean} true if the given value contains the given text.
 */
export function matchesTransformedText(value, text, textTransformation) {
    if (textTransformation && isFunction(textTransformation)) {
        return String(textTransformation(value)).toLowerCase().includes(String(text).toLowerCase())
    }
    return String(value).toLowerCase().includes(String(text).toLowerCase())
}
